import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { TopContentsContainer } from "scmp-app/components/topic/topic-top-contents/styles";
import { borderStyle } from "scmp-app/pages/topic/styles";

export const TopContentsRestContainer = styled.div`
  display: grid;
  grid:
    "rest-contents" min-content
    "rest-ads" min-content
    / minmax(0, 1fr);

  ${theme.breakpoints.up("desktop")} {
    grid:
      "rest-contents rest-ads" min-content
      / minmax(0, 1fr) minmax(0, 300px);
    column-gap: 40px;
  }
`;

export const TopContentsRestContents = styled(TopContentsContainer)`
  grid-area: rest-contents;

  ${borderStyle}
`;

export const AdsRest = styled.div`
  grid-area: rest-ads;

  margin-block-end: 32px;
  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 0;
  }
`;
